import {format, intervalToDuration, formatDuration as DateFnsFormatDuration} from 'date-fns';

interface FormatOptions {
  locale?: Locale;
  weekStartsOn?: 0 | 1 | 2 | 3 | 4 | 5 | 6;
  firstWeekContainsDate?: number;
  useAdditionalWeekYearTokens?: boolean;
  useAdditionalDayOfYearTokens?: boolean;
}

export const formatDate = (date: string | number, fnsFormat: string, options?: FormatOptions) => {
  try {
    const d = new Date(date);

    if (Number.isNaN(d.getTime())) {
      return '';
    }

    return format(d, fnsFormat, options);
  } catch (e) {
    return 'Invalid Date';
  }
};

const formatDistanceLocale = {
  xSeconds: '{{count}}s',
  xMinutes: '{{count}}m',
  xHours: '{{count}}h',
};
const shortEnLocale: Locale = {
  formatDistance: (token, count) =>
    formatDistanceLocale[token as keyof typeof formatDistanceLocale].replace('{{count}}', count),
};

export const formatDuration = (seconds: number) => {
  if (!seconds) {
    return '0s';
  }

  const duration = intervalToDuration({start: 0, end: seconds * 1000});

  return DateFnsFormatDuration(duration, {
    format: ['hours', 'minutes', 'seconds'],
    delimiter: ' ',
    locale: shortEnLocale,
  });
};
